/**
 * 捨てアドレス（使い捨てメールアドレス）のドメインリスト
 * このリストに含まれるドメインからの登録を制限します
 */

export const disposableEmailDomains = [
    // 一般的な使い捨てメールサービス
    'temp-mail.org',
    'guerrillamail.com',
    'guerrillamailblock.com',
    'sharklasers.com',
    'mailinator.com',
    'tempmail.net',
    'dispostable.com',
    'yopmail.com',
    'tempinbox.com',
    'maildrop.cc',
    'getairmail.com',
    '10minutemail.com',
    '10minutemail.net',
    '10minutemail.org',
    'mailnesia.com',
    'trashmail.com',
    'mailnator.com',
    'trashmail.net',
    'getnada.com',
    'temp-mail.io',
    'fakeinbox.com',
    'tempmail.plus',
    'throwawaymail.com',
    'throwmail.com',
    'hulapla.de',
    'tempail.com',
    'fake-mail.net',
    'mytrashmail.com',

    // 日本の捨てアドレスサービス
    'f5.si',
    'm.f5.si',
    'w.f5.si',
    'a.f5.si',
    'p.f5.si',
    'mofmof.jp',
    'cc.mofmof.jp',
    'mail.goo.jp',
    'svk.jp',
    'via.tokyo.jp',
    'maill.host',
    'mailloki.com',
    'disposable.email',
    'tempr.email',
    'tempemail.co',

    // その他の国際的な捨てアドレスサービス
    'spamgourmet.com',
    'jetable.org',
    'anonbox.net',
    'moakt.com',
    'emailondeck.com',
    'emailfake.com',
    'tempmailo.com',
    'gmailzxc.com',

    // 追加の捨てアドレスドメイン
    'one-ml.com',
    'dea-21olympic.com',
    'cazlv.com',
    '1xp.fr',
    'cpc.cx',
    '0cd.cn',
    'prc.cx',
    'b7s.ru',
    'ab34.fr',
    'e3b.org',
    'new.ovh',
    'ves.ink',
    'q0.us.to',
    'zx81.ovh',
    'wishy.fr',
    'bmn.ch.ma',
    'iya.fr.nf',
    'sdj.fr.nf',
    'afw.fr.nf',
    'mail34.fr',
    'mynes.com',
    'dao.pp.ua',
    'nori24.tv',
    'lerch.ovh',
    'breizh.im',
    'six25.biz',
    'art.fr.cr',
    'red.fr.cr',
    'ywzmb.top',
    'nyndt.top',
    'isep.fr.nf',
    'noreply.fr',
    'pliz.fr.nf',
    'noyp.fr.nf',
    'zouz.fr.nf',
    'hunnur.com',
    'wxcv.fr.nf',
    'zorg.fr.nf',
    'imap.fr.nf',
    'redi.fr.nf',
    'dlvr.us.to',
    'y.iotf.net',
    'zinc.fr.nf',
    'ym.cypi.fr',
    'yop.too.li',
    'dmts.fr.nf',
    'binich.com',
    'wzofit.com',
    'jmail.fr.nf',
    'zimel.fr.cr',
    'yaloo.fr.nf',
    'jinva.fr.nf',
    'ag.prout.be',
    'ba.prout.be',
    'es.prout.be',
    'us.prout.be',
    'ealea.fr.nf',
    'nomes.fr.nf',
    'yop.kd2.org',
    'my10minutemail.com',
    'trashmail.fr',
    'trashmail.se',
    'gomio.biz',
    'macr2.com',
    'ruru.be',
    'neko2.net',
    'fuwamofu.com',
    'merry.pink',
    'cream.pink',
    'choco.la',
    'ichigo.me',
    'eay.jp',
    'usako.net',
    'mofu.be',
    'prin.be',
    'kkmail.be',
    'niseko.be',
    'sendapp.uk',
    'instmail.uk',
    'nekosan.uk',
    'meruado.uk',
    'instaddr.win',
    'instaddr.uk',
    'quicksend.ch',
    'instaddr.ch',
    'uma3.be',
    'mbox.re',
    'honeys.be',
    'heisei.be',
    'moimoi.re',
    'mirai.re',
    'magim.be',
    'fuwari.be',
    'nagi.be',
    'kagi.be',
    'tapi.re',
    'simaenaga.com',
    'sofia.re',
    'hotsoup.be',
    'nekochan.fr',
    'fanclub.pm',
    'okinawa.li',
    'stayhome.li',
    'owleyes.ch',
    'nezumi.be',
    'fukurou.ch',
    'digdig.org',
    'mama3.org',
    'hamham.uk',
    'cocoro.uk',
    'exdonuts.com',
    'na-cat.com',
    'xmailer.be',
    'ccmail.uk',
    'nyasan.com',
    'sendnow.win',
    'eripo.net',
    'goatmail.uk',
    'catgroup.uk',
    'shchiba.uk',
    'bangban.uk',
    'onlyapp.net',
    'haren.uk',
    'tatsu.uk',
    'proton.me',
    'protonmail.com',
    'sute.jp',
    'mxscout.com'
];

/**
 * メールアドレスが捨てアドレスかどうかをチェックする関数
 * @param {string} email - チェックするメールアドレス
 * @returns {boolean} - 捨てアドレスであればtrue、そうでなければfalse
 */
export const isDisposableEmail = (email) => {
    if (!email) return false;

    // メールアドレスからドメイン部分を抽出
    const domain = email.split('@')[1]?.toLowerCase();
    if (!domain) return false;

    // 登録済みの捨てアドレスドメインと一致するかチェック
    return disposableEmailDomains.includes(domain);
};

/**
 * 捨てアドレスチェックのエラーメッセージ
 */
export const DISPOSABLE_EMAIL_ERROR = '捨てアドレスでの登録はできません。正規のメールアドレスを使用してください。'; 